import Rx from "rxjs/Rx";
import $ from "jquery";

const searchInputId = "search-input";
const autocompletePlaceChangedSource = new Rx.Subject();

/**
 * @event {Object} autocompletePlaceChanged$ - {lat, lng, formatted_address}
 */
export default class AutocompleteService {
    constructor() {
        this.gmAutocomplete = null;

        this.initialize();
    }

    /**
     * @returns {(string|Object)} address or null
     */
    static get firstOptionFromHiddenAutocomplete() {
        const htmlFromAutoComplete = $(".pac-container .pac-item:first")
            .eq(0)
            .html();
        if (!htmlFromAutoComplete) {
            return null;
        }
        const spans = $(".pac-container .pac-item:first span");
        const arr = [];
        spans.each(function pushTextIfItHasValidClass() {
            if (!$(this).hasClass("pac-matched")) {
                const text = $(this).text();
                if (text) {
                    arr.push(text);
                }
            }
        });

        return arr.join(" ");
    }

    initialize() {
        if (document.getElementById(searchInputId)) {
            // eslint-disable-next-line eqeqeq
            const isExpirienceEditor = $("#current-sitecore-context").data("ee") == "1";

            if (typeof window.google !== "undefined" && typeof window.google.maps !== "undefined") {
                this.gmAutocomplete = this.createGMAutocomplete();
                this.initHandlingOnGMPlaceChanged();
            }
        }
    }

    initHandlingOnGMPlaceChanged() {
        window.google.maps.event.addListener(this.gmAutocomplete, "place_changed", () => {
            const place = this.gmAutocomplete.getPlace();
            if (
                place
                && place.geometry
                && place.geometry.location
                && place.geometry.location.lat
                && place.geometry.location.lng
            ) {
                autocompletePlaceChangedSource.next({
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    formatted_address: place.formatted_address,
                    address_components: place.address_components,
                });
            }
        });
    }

    /**
     * @returns {Object} - Google Maps Autcomplete instance
     */
    // eslint-disable-next-line class-methods-use-this
    createGMAutocomplete() {
        const options = {
            componentRestrictions: {
                country: "fi",
            },
            types: ["geocode"],
        };

        const autocomplete = new window.google.maps.places.Autocomplete(
            document.getElementById(searchInputId),
            options,
        );

        return autocomplete;
    }
}

AutocompleteService.autocompletePlaceChanged$ = autocompletePlaceChangedSource.asObservable();
